export default {
  INSULATOR: 'INSULATOR',
  SUPPORT: 'SUPPORT',
  BETWEEN_CHEVRON: 'BETWEEN_CHEVRON',
  UNDER_CHEVRON: 'UNDER_CHEVRON',
  SHROUD: 'SHROUD',
  MEMBRANE: 'MEMBRANE',
  SOLIDOUBLE: 'SOULIDOUBLE',
  ADHESIVE: 'ADHESIVE',
  MASTIC: 'MASTIC',
  MANCHON: 'MANCHON',
  PASTILLE: 'PASTILLE',
  INSULATOR_BETWEEN: 'INSULATOR_BETWEEN',
  INSULATOR_BLOWN: 'INSULATOR_BLOWN',
  INSULATOR_SECOND: 'INSULATOR_SECOND',
};



// WEBPACK FOOTER //
// ./src/constants/ProductType.js